@if (appState === 'loading') {
<app-loading />
} @else if (appState === 'error') {
<app-error-page />
} @else if (appState === 'success') {
<div class="w-full h-full flex justify-center items-center p-5">
  <div class="success-content">
    <div class="success-icon">
      <svg
        width="64"
        height="64"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" fill="#4CAF50" />
        <path
          d="M8 12l2 2 4-4"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <h1 class="success-title">¡Validación Exitosa!</h1>
    <p class="success-message">
      Tu clave dinámica ha sido validada correctamente.
    </p>
    <p class="success-submessage">Puedes continuar con el proceso.</p>
  </div>
</div>
} @else {
<!-- Estado OTP -->
<form [formGroup]="otpForm" class="otp-form" (submit)="onSubmit()">
  <div class="info-container">
    <h1 class="titulo">Ingresa la Clave Dinámica</h1>

    <div class="texto">
      <span>Te enviamos la clave a:</span>

      <ul>
        @if(correoCliente){
        <li class="pl-3 before:content-['•'] before:inline-block before:mr-2">
          Tu correo registrado
          <span style="font-weight: 600">{{
            contactData?.datos?.correo || "****"
          }}</span>
        </li>
        } @if(telefonoCliente){
        <li class="pl-3 before:content-['•'] before:inline-block before:mr-3">
          @if(correoCliente) {<span>Y por mensaje de texto a </span>}
          <span [class.capitalize]="!correoCliente">tu</span> número registrado
          <br />
          <span style="font-weight: 600">{{
            contactData?.datos?.telefono || "****"
          }}</span>
        </li>
        }
      </ul>
    </div>
  </div>

  <span class="text-[#586E89] text-xl text-center">
    Tienes
    <span style="font-weight: 600">tres intentos y 5 minutos</span> para
    ingresarla</span
  >

  <div class="otp-container">
    <div class="otp-input-container">
      @for(control of otpForm.controls | keyvalue; track control.key) {
      <input
        name="{{ control.key }}"
        formControlName="{{ control.key }}"
        type="text"
        maxlength="1"
        class="otp-input"
        [class.error]="errorValidator(otpForm, control.key)"
        [disabled]="intentosActuales() === 0"
        pattern="[0-9]{1}"
        inputmode="numeric"
        soloNumeros
        (input)="onInputChange($event, $index)"
        (keydown)="onKeyDown($event, $index)"
        (paste)="onPaste($event)"
        (focus)="onFocus($event)"
        (blur)="onBlur($event)"
      />
      }
    </div>
    @if(errorOtp() && intentosActuales() > 0) {
    <small style="color: var(--color-error)"
      >La clave es incorrecta, te quedan
      {{ intentosActuales() }} intentos</small
    >
    } @else {
    <small>Ingresa los 6 dígitos</small>
    }
  </div>

  @if(isCargando()) {
  <div class="spinner-sm" style="margin: auto"></div>
  } @else {
  <button
    class="boton"
    type="submit"
    style="margin: auto"
    [disabled]="!isFormValid || intentosActuales() === 0"
  >
    Continuar
  </button>
  }

  <otp-info-card />
</form>
}
